import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getProducts({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {
        commit('GET_PRODUCTS_REQUEST')

        return axios
            .get(`/products/product-types${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_PRODUCTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCTS_FAILURE')
                handleApiError(error, 'Pobranie listy produktów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProduct(context, id) {
        return axios
            .get(`/products/product-types/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych produktu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    saveProduct({ commit }, { id, payload }) {
        return axios
            .put(`/products/product-types/${id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zapisano ustawienia produktu.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis produktu nie powiódł się.')

                return Promise.reject(error)
            })
    },
    getProductComponents() {
        return axios
            .get('/products/product-components')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie komponentów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductProductionProperties(context, { query = ''} = {}) {
        return axios
            .get(`/products/product-production-properties${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie cech produkcyjnych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductProperties() {
        return axios
            .get('/products/product-properties')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie parametrów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductPropertiesByProductType(context, productTypeId) {
        return axios
            .get(`/products/product-properties?productTypeId=${productTypeId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie parametrów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductProductionPropertyValues() {
        return axios
            .get('/products/product-production-property-values')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie wartości cech produkcyjnych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductPropertyValuesByProductType(context, productTypeId) {
        return axios
            .get(`/products/product-property-values?productTypeId=${productTypeId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie cech sklepowych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionProductTypePropertyValues(context, productPropertyValueJoinId) {
        return axios
            .get(`/products/production-product-type-property-values?productPropertyValueJoinId=${productPropertyValueJoinId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie rozpisanych cech produkcyjnych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createProductionProductTypePropertyValue(context, payload) {
        return axios
            .post('/products/production-product-type-property-values', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie definicji cechy produkcyjnej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateProductionProductTypePropertyValue(context, payload) {
        return axios
            .put(`/products/production-product-type-property-values/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja definicji cechy produkcyjnej nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteProductionProductTypePropertyValue(context, id) {
        return axios
            .delete(`/products/production-product-type-property-values/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie definicji cechy produkcyjnej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    validateProductionPropertyAlgorithm(context, payload) {
        return axios
            .post('/products/product-components/validate', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Algorytm jest niepoprawny.')

                return Promise.reject(error)
            })
    },
    setProductsFilters({ commit }, filters) {
        commit('SET_PRODUCTS_FILTERS', filters)
    },
    clearProductsFilters({ commit }) {
        commit('CLEAR_PRODUCTS_FILTERS')
    }
}